function ConvertPersianToEnglish(numberString) {
    const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    const englishDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];


    if (typeof numberString !== 'string') return numberString;


    return numberString.replace(/[۰-۹]/g, (match) => {
        const index = persianDigits.indexOf(match);
        return englishDigits[index] || match; // Handle non-digit characters
    });
}

export default ConvertPersianToEnglish;